import type { ServerTier, TierConfig, MediaHoursUsage, FuelContributor } from '@/types'

export const TIER_CONFIGS: Record<ServerTier, TierConfig> = {
  free: {
    id: 'free',
    label: 'Free',
    price: 0,
    annualPrice: 0,
    members: 15,
    mediaHours: 300,
    textChannels: 2,
    voiceChannels: 1,
    video: false,
    screenShare: false,
    goLive: false,
    storage: 0.5,
    customEmoji: 0,
    overageRate: null,
    overageCap: null,
    messageHistory: 'Hot window',
    moderation: '—',
    botSlots: 0,
    analytics: '—',
    fuelEnabled: false,
    fuelPrice: 0,
    color: '#8B95A8',
  },
  spark: {
    id: 'spark',
    label: 'Spark',
    price: 4,
    annualPrice: 38,
    members: 50,
    mediaHours: 1500,
    textChannels: 10,
    voiceChannels: 3,
    video: '720p',
    screenShare: false,
    goLive: false,
    storage: 5,
    customEmoji: 25,
    overageRate: null,
    overageCap: null,
    messageHistory: '30 days',
    moderation: 'Basic',
    botSlots: 2,
    analytics: '—',
    fuelEnabled: true,
    fuelPrice: 2,
    color: '#3ECF7B',
  },
  blaze: {
    id: 'blaze',
    label: 'Blaze',
    price: 12,
    annualPrice: 115,
    members: 200,
    mediaHours: 5000,
    textChannels: 30,
    voiceChannels: 8,
    video: '720p',
    screenShare: '720p',
    goLive: false,
    storage: 25,
    customEmoji: 50,
    overageRate: 0.10,
    overageCap: 50,
    messageHistory: '90 days',
    moderation: 'Full',
    botSlots: 5,
    analytics: '—',
    fuelEnabled: true,
    fuelPrice: 2,
    color: '#E8A840',
  },
  forge: {
    id: 'forge',
    label: 'Forge',
    price: 25,
    annualPrice: 240,
    members: 1000,
    mediaHours: 12000,
    textChannels: null,
    voiceChannels: 20,
    video: '1080p',
    screenShare: '1080p',
    goLive: { quality: '720p', maxViewers: 50 },
    storage: 100,
    customEmoji: 200,
    overageRate: 0.08,
    overageCap: 100,
    messageHistory: 'Unlimited',
    moderation: 'Full + audit log',
    botSlots: 20,
    analytics: 'Basic',
    fuelEnabled: true,
    fuelPrice: 3,
    color: '#CF3E4F',
  },
  legion: {
    id: 'legion',
    label: 'Legion',
    price: 60,
    annualPrice: 576,
    members: 5000,
    mediaHours: 30000,
    textChannels: null,
    voiceChannels: null,
    video: '1080p',
    screenShare: '1080p',
    goLive: { quality: '1080p', maxViewers: 150 },
    storage: 500,
    customEmoji: 500,
    overageRate: 0.05,
    overageCap: 200,
    messageHistory: 'Unlimited',
    moderation: 'Full + API access',
    botSlots: null,
    analytics: 'Advanced',
    fuelEnabled: true,
    fuelPrice: 3,
    color: '#A855F7',
  },
}

export const FUEL_LEVELS = [
  { level: 1, goal: 5, perks: 'Custom server icon animation' },
  { level: 2, goal: 15, perks: 'HD voice channels + custom banner' },
  { level: 3, goal: 30, perks: 'Vanity URL + 1080p streaming' },
]

export const serverBilling: Record<string, { usage: MediaHoursUsage; fuelContributors: FuelContributor[] }> = {
  s1: {
    usage: {
      voiceMH: 2800,
      videoMH: 360,
      screenShareMH: 40,
      goLiveMH: 0,
      totalMH: 3200,
      periodStart: '2026-03-01',
      periodEnd: '2026-03-31',
    },
    fuelContributors: [
      { userId: 'u2', sinceDate: '2026-01-15' },
      { userId: 'u3', sinceDate: '2026-02-01' },
      { userId: 'u4', sinceDate: '2026-01-20' },
      { userId: 'u5', sinceDate: '2026-02-10' },
      { userId: 'u7', sinceDate: '2026-01-25' },
      { userId: 'u8', sinceDate: '2026-02-05' },
      { userId: 'exp1-u1', sinceDate: '2026-02-15' },
      { userId: 'exp1-u2', sinceDate: '2026-02-20' },
    ],
  },
  s2: {
    usage: {
      voiceMH: 7200,
      videoMH: 1800,
      screenShareMH: 600,
      goLiveMH: 200,
      totalMH: 9800,
      periodStart: '2026-03-01',
      periodEnd: '2026-03-31',
    },
    fuelContributors: [
      { userId: 'u3', sinceDate: '2026-01-10' },
      { userId: 'u7', sinceDate: '2026-02-01' },
      { userId: 'u8', sinceDate: '2026-02-15' },
    ],
  },
  s3: {
    usage: {
      voiceMH: 150,
      videoMH: 30,
      screenShareMH: 0,
      goLiveMH: 0,
      totalMH: 180,
      periodStart: '2026-03-01',
      periodEnd: '2026-03-31',
    },
    fuelContributors: [],
  },
  s4: {
    usage: {
      voiceMH: 18,
      videoMH: 2,
      screenShareMH: 0,
      goLiveMH: 0,
      totalMH: 20,
      periodStart: '2026-03-01',
      periodEnd: '2026-03-31',
    },
    fuelContributors: [],
  },
}
